import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree } from '@angular/router';
import { IUser, ProgramStatusService } from '@ebb-v2/ebb-integration';
import { Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';

import { AccountsService } from './modules/registration/services/accounts/accounts.service';

@Injectable({ providedIn: 'root' })
export class AuthGuard implements CanActivate {
    public currentUser: IUser = {} as IUser;
    
    constructor(
        private router: Router,
        private accountsService: AccountsService,
        private programstatus: ProgramStatusService
    ) {}

    canActivate(
        next: ActivatedRouteSnapshot,
        state: RouterStateSnapshot
    ): Observable<boolean> {
        const programTypeCodeOptionSet = this.accountsService.programTypeCodeOptionSet;

        return this.programstatus.checkProgramstatus(programTypeCodeOptionSet).pipe(
            map(data => {
                if (!data) {
            
                    return false;
                } else {
                    return true;
                }
            })
        );
    }
}
